// DESIGN V2 — the sidebar's navigation, one source of truth. `cat` is the
// classic category (App.js's ALL_CATEGORIES) each page belongs to; the
// sidebar dispatches setActiveCategory(cat) + setActiveTab(key), nothing else
// changes. Groups are how the rail READS, not how the app is organised:
// daily pages first, the collection, then the tools people run once per
// import.
// v2's own For You (headphones) and Mixpedia (record) icons; classic keeps the
// feed / crosshair ones in assets/icons/categories.
import { ReactComponent as feedIcon } from '../../assets/icons/v2/for-you.svg';
import { ReactComponent as mixpediaIcon } from '../../assets/icons/v2/mixpedia.svg';
import { ReactComponent as whatsnextIcon } from '../../assets/icons/categories/whatsnext.svg';
import { ReactComponent as recommendationsIcon } from '../../assets/icons/categories/recommendations.svg';
import { ReactComponent as libraryIcon } from '../../assets/icons/categories/library.svg';
import { ReactComponent as organizeIcon } from '../../assets/icons/categories/organize.svg';
import { ReactComponent as metadataIcon } from '../../assets/icons/categories/metadata.svg';
import { ReactComponent as migrateIcon } from '../../assets/icons/categories/migrate.svg';
import { ReactComponent as compatibilityIcon } from '../../assets/icons/categories/compatibility.svg';
import { ReactComponent as loudnessIcon } from '../../assets/icons/categories/loudness.svg';
import { ReactComponent as cuePointsIcon } from '../../assets/icons/categories/cuepoints.svg';
import { ReactComponent as automixIcon } from '../../assets/icons/categories/automix.svg';

export const NAV_GROUPS = [
    {
        id: 'discover', label: 'Discover',
        items: [
            { key: 'feed', title: 'For You', icon: feedIcon, cat: 'explore' },
            { key: 'djpal', title: 'Mixpedia', icon: mixpediaIcon, cat: 'explore' },
            // Finding records in the style of a playlist is discovery, not creation.
            { key: 'smart-recs', title: 'Crate Digger', icon: recommendationsIcon, cat: 'explore' },
        ],
    },
    {
        // Making something: a set, a mix. Automix records a mix from a
        // playlist — it belongs with the other creation tools, not with repairs.
        id: 'create', label: 'Create',
        items: [
            { key: 'whats-next', title: 'Set Planner', icon: whatsnextIcon, cat: 'explore' },
            { key: 'automix', title: 'Automix', icon: automixIcon, cat: 'prepare', needsAutomix: true },
        ],
    },
    {
        // The collection panels (Playlists / Liked / Favourite artists) render
        // after these items — see SideNav.
        id: 'collection', label: 'Collection',
        items: [
            { key: 'visualize', title: 'Library', icon: libraryIcon, cat: 'library' },
        ],
    },
    {
        id: 'tools', label: 'Tools',
        items: [
            // Ordered by how often a DJ reaches for each: every track, every set, per software, occasional, rare, once.
            { key: 'cue-points', title: 'Cues & Loops', icon: cuePointsIcon, cat: 'prepare' },
            { key: 'match-loudness', title: 'Loudness', icon: loudnessIcon, cat: 'prepare' },
            { key: 'fix-my-tracks', title: 'Compatibility', icon: compatibilityIcon, cat: 'prepare' },
            { key: 'fix-metadata', title: 'Metadata', icon: metadataIcon, cat: 'library' },
            { key: 'organize-tracks', title: 'Organize', icon: organizeIcon, cat: 'library' },
            { key: 'migrate-library', title: 'Migrate', icon: migrateIcon, cat: 'library' },
        ],
    },
];
